import { Actions, Atom, Data } from "@cirrus/fe-lib"

import { CoreConfig as params } from "./_params.js"
import { I18nConfig } from "./i18n/index.js"

export const CoreConfig = {
  params: Data.merged(params, { i18n: I18nConfig.params }),
  domain: params.domain,
  actions: Actions.from(I18nConfig),
  atom: Atom.from(I18nConfig),
  effects: I18nConfig.effects,
  state: { i18n: I18nConfig.state },
  ui: { i18n: I18nConfig.ui },
}
